import React, { useState } from 'react';
import Design from '../../assets/design.svg';
import Technical from '../../assets/technical.svg';
import Management from '../../assets/management.svg';
import Editorial from '../../assets/editorial.svg';

const Domain = () => {
  const [count, setCount] = useState(0);
  function handleClickS(e) {
    e.preventDefault();
    setCount(count + 1);

    if (count === 9) {
      window.location.href = 'https://www.linkedin.com/in/souvik-mukherjee-355943123/';
    }
  }

  function handleClickA(e) {
    e.preventDefault();
    setCount(count + 1);

    if (count === 9) {
      window.location.href = 'https://www.linkedin.com/in/ayushi-prasad-59310a1a0/';
    }
  }
  return (
    <div>
      <div className="domain-section-1 relative flex flex-col items-start ">
        <h2 className="z-20 pb-8 text-4xl font-bold text-white md:py-12 md:text-6xl lg:py-12 lg:text-6xl">
          OUR DOMAINS
        </h2>
        <div className="flex flex-col justify-between  md:flex-row md:py-12 lg:flex-row lg:py-12">
          <div className="glass-effect mx-0 w-80 text-white md:mx-16 lg:mx-16">
            <div className="flex flex-col items-center justify-center">
              <img src={Technical} alt="" className="w-14 py-3 md:w-20 lg:w-24" onClick={handleClickS} />
              <h1 className="text-2xl">Technical</h1>
            </div>
          </div>
          <div className="h-10"></div>
          <div className="glass-effect  mx-0 w-80 text-white md:mx-16 lg:mx-16">
            <div className="flex flex-col items-center justify-center">
              <img src={Design} alt="" className="w-14 py-3 md:w-20 lg:w-24" onClick={handleClickA} />
              <h1 className="text-2xl">Design</h1>
            </div>
          </div>
        </div>
        <div className="h-10"></div>
        <div className="flex flex-col justify-between md:flex-row md:py-12 lg:flex-row lg:py-12">
          <div className="glass-effect  mx-0 w-80 text-white md:mx-16 lg:mx-16">
            <div className="flex flex-col items-center justify-center">
              <img src={Management} alt="" className="w-14 py-3 md:w-20 lg:w-24" />
              <h1 className="text-2xl">Management</h1>
            </div>
          </div>
          <div className="h-10"></div>
          <div className="glass-effect  mx-0 w-80 min-w-max text-white md:mx-16 lg:mx-16">
            <div className="flex flex-col items-center justify-center">
              <img src={Editorial} alt="" className="w-14 py-3 md:w-20 lg:w-24" />
              <h1 className="text-2xl">Editorial</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Domain;
